import React from 'react'
// components
import TableManagementProvider from 'containers/Search/layers/BL'
import PlanTypes from 'components/PageComponents/Settings/PlanTypes/Register'
import PlanTypesPageAPI from './layers/API'

const PlanTypesContainer: React.FC = () => (
  <TableManagementProvider>
    <PlanTypesPageAPI>
      <PlanTypes />
    </PlanTypesPageAPI>
  </TableManagementProvider>
)

export default PlanTypesContainer
